import dayjs from "dayjs";

/**
 * 获取距离现在的时间多久
 * @param {number | string} time 用于与现在比较的时间
 * @param {string} afterText 时间后添加的文本
 * @param {boolean} reverse 反向比较时间，用于计算什么时候过期使用
 * @returns {string} 1年前  4秒前  1分钟前
 */
export default function getTimeDuration(time, afterText = "前", reverse) {
  // 时间差
  let now = dayjs();
  let pre = dayjs(time);
  if (reverse) {
    const temp = pre;
    pre = now;
    now = temp;
  }

  const mapList = [
    ["year", "年"],
    ["M", "月"],
    ["d", "天"],
    ["h", "小时"],
    ["m", "分钟"],
    ["s", "秒"],
  ];

  for (let i = 0; i < mapList.length; i++) {
    const [unit, unitText] = mapList[i];
    let diff = now.diff(pre, unit, true);
    if (diff >= 1) {
      return `${diff.toFixed()}${unitText}${afterText}`;
    }
  }

  return reverse ? "即将" : "刚刚";
}
